import React, { useEffect, useState } from "react";
import Fdes from "../components/Fdes";
import { withPermissions } from "../../../layout/Permissions";
import { PERMISSION_USER } from "../../user/constants/permissions";
import { useParams } from "react-router-dom";
import { FINISHED } from "../../calcul/constants";

const FdesEditPage = ({
  user,
  formIsLoading,
  familyProducts,
  loadFdesParameters,
  isEdited,
  saveFdesForm,
  loadReference,
  saveFdesResult,
  resultFormIsLoading,
  resultFormIsSaved,
  generateReports,
  calculs,
  updateCalcul,
  saveFdesRealTimeForm,
  isGeneratingReports,
  onUpgradeCalcul,
  calculIsLoading,
  getFdesMetadata,
  metadata,
  getCalcul,
  calcul,
  sendXmlToEDEC,
  reports,
  removeReports,
  isSaved,
  isFormUpdated,
  getLocalEDECIntegration,
  localConfigurator,
  localEDECIntegration,
  simulationMode,
  clearCalcul,
  fdesParameters,
}) => {
  const [familyProduct, setFamilyProduct] = useState({});
  const params = useParams();

  useEffect(() => {
    if (localConfigurator.id) {
      getLocalEDECIntegration();
    }
  }, [localConfigurator.id]); //eslint-disable-line

  function calculSimulationMode() {
    if (calcul.model?.settings?.simulation?.active === true) {
      return calcul?.options?.simulationMode === true;
    } else return false;
  }

  useEffect(() => {
    if (params && params.familyProductId) {
      const flatten = (routes) =>
        routes.reduce((acc, r) => {
          if (r.children && r.children.length) {
            acc = acc.concat(flatten(r.children));
          }
          acc.push(r);

          return acc;
        }, []);
      setFamilyProduct(
        flatten(familyProducts).find((x) => x._id === params.familyProductId),
      );
    }
  }, [params, familyProducts, calculs]);

  function isGenerateButtonDisabled() {
    return (
      calcul?.status === FINISHED ||
      isGeneratingReports ||
      !isEdited ||
      !resultFormIsSaved ||
      filesCreatedAfterSave()
    );
  }

  function filesCreatedAfterSave() {
    if (calcul.status === FINISHED) return true;
    if (
      reports?.createdAt &&
      calcul?.updatedAt &&
      (reports?.xml || reports?.pdf || reports?.xls || reports?.xmlInies)
    ) {
      return new Date(reports.createdAt) > new Date(calcul.updatedAt);
    } else return false;
  }

  const isReadOnly = () => {
    if (calcul?.status === FINISHED) return true;
    if (!calculSimulationMode()) {
      return (
        filesCreatedAfterSave() ||
        !!(
          calcul &&
          calcul.lastModel &&
          calcul.lastModel._id !== calcul.model._id
        )
      );
    } else return false;
  };

  return (
    <>
      <Fdes
        user={user}
        familyProduct={familyProduct}
        loadFdesParameters={loadFdesParameters}
        isEdited={isEdited}
        saveFdesForm={saveFdesForm}
        saveFdesRealTimeForm={saveFdesRealTimeForm}
        loadReference={loadReference}
        saveFdesResult={saveFdesResult}
        resultFormIsLoading={resultFormIsLoading}
        resultFormIsSaved={resultFormIsSaved}
        generateReports={generateReports}
        calcul={calcul}
        updateCalcul={updateCalcul}
        readOnly={isReadOnly()}
        isSimulationMode={!!simulationMode}
        isGeneratingReports={isGeneratingReports}
        onUpgradeCalcul={onUpgradeCalcul}
        calculIsLoading={calculIsLoading}
        formIsLoading={formIsLoading}
        getFdesMetadata={getFdesMetadata}
        metadata={metadata}
        id={params ? params.calculId : undefined}
        getCalcul={getCalcul}
        sendXmlToEDEC={sendXmlToEDEC}
        reports={reports}
        removeReports={removeReports}
        filesCreatedAfterSave={filesCreatedAfterSave}
        isGenerateButtonDisabled={isGenerateButtonDisabled()}
        isSaved={isSaved}
        isFormUpdated={isFormUpdated}
        localEDECIntegration={localEDECIntegration}
        clearCalcul={clearCalcul}
        fdesParameters={fdesParameters}
      />
    </>
  );
};

export default withPermissions(FdesEditPage, PERMISSION_USER);
